const fetchArticle = (url = "") => fetch(url, {
    method: "GET"
  }).then(res => {
    if (res.status !== 200) return Promise.reject(res);
    return res.text();
  });
export default fetchArticle;
